import { useEffect, useRef, useState } from "react";
import Image from 'next/image';
import { VideoProps } from "./Homepage";
import ReactPlayer from 'react-player/youtube';


interface MamapediaVideoListProps {
  videos: Array<VideoProps>;
}

const MamapediaVideoList = (props: MamapediaVideoListProps) => {
  const { videos } = props
  const [video, setVideo] = useState<string | null>(null);
  const [desktopVideoHeight, setDesktopVideoHeight] = useState(0);
  const desktopVideoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (desktopVideoRef.current !== null) {
      setDesktopVideoHeight(desktopVideoRef.current.offsetWidth * 0.5625);
    }
  }, [])

  useEffect(() => {
    if (videos.length > 0) {
      setVideo(videos[0].video_id);
    }
  }, [videos])

  return (
    <div className="hidden md:grid grid-cols-3 gap-20 bg-topTextBg container py-12 mt-12 font-poppins">
      <div className="col-span-2">
        <h3 className="text-base text-black font-bold mb-4">MOOIMOM Channel</h3>
        <div ref={desktopVideoRef}>
          <ReactPlayer
            url={`https://www.youtube.com/watch?v=${video}`}
            width="100%"
            height={desktopVideoHeight}
            playing={false}
            loop={true}
            controls={true}
            muted={true}
          />
        </div>
      </div>
      <div className="col-span-1">
        <p className="text-sm text-black font-semibold mb-4">Video Lainnya</p>
        <div className="h-[440px] overflow-y-auto">
          {videos.map((video, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 cursor-pointer"
              onClick={() => setVideo(video.video_id)}
            >
              <Image
                src={`https://img.youtube.com/vi/${video.video_id}/0.jpg`}
                alt={video.name}
                quality={100}
                width={1200}
                height={800}
                className="w-1/2 object-cover mb-4 rounded"
              />
              <p className="text-xs text-black line-clamp-3 text-ellipsis h-12">{video.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default MamapediaVideoList
